import React from 'react';
import type { ExistingLinePick } from '../useManualImport';
import { ProductPickerView } from './ProductPickerView';
import { useProductPicker } from './useProductPicker';

type ProductPickerProps = {
    onPick: (pick: ExistingLinePick) => void;
};

/**
 * "Add product" picker: container wires {@link useProductPicker} (search +
 * variant-pick flow, open/close state) into the render-only `ProductPickerView`.
 */
export const ProductPicker: React.FC<ProductPickerProps> = ({ onPick }) => {
    const picker = useProductPicker(onPick);

    return <ProductPickerView picker={picker} />;
};
